import { getProductFormField } from '../utils';
import Component from './ProductFormSelect';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
